<ion-card [ngClass]="{'desktop': !isMobile}">
  <ion-card-header>
    <ion-card-title>{{card.value ? card.value : '0'}}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <h2>{{card.title}}</h2>
  </ion-card-content>
</ion-card>